import { Size } from "../../../constants";

const DEFAULT_WIDTH = '60';

export function getWidth(size?: Size) {
    let width: string;

    switch (size) {
        case Size.xs:
            width = '30';
            break
        case Size.sm:
            width = '48';
            break;
        case Size.lg:
            width = '75';
            break;
        case Size.xl:
            width = '90';
            break;
        case Size.md:
        default:
            width = DEFAULT_WIDTH;
    }

    return width;
}